import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback } from 'react';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { useDisabledDatePresets } from '@/App/tiles/shared/useDisabledDatePresets.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorFirstFixing,
  selectForwardAccumulatorProperty,
  selectForwardAccumulatorValidation,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';

const FirstFixingDate = () => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();

  const { firstFixingDate, firstFixingTenor } = useAppSelector((state) =>
    selectForwardAccumulatorFirstFixing(state, tileId),
  );
  const currencyPair = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'currencyPair'));
  const disabledDatePresets = useDisabledDatePresets(tileId, currencyPair);

  const validation = useAppSelector((state) => selectForwardAccumulatorValidation(state, tileId));

  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleDateChange = useCallback(
    (dateOrTenor: string) => {
      sgwtWebAnalytics?.trackEvent('ForwardAccumulator', 'First Fixing Date changed', dateOrTenor);

      check({
        firstFixingDate: dateOrTenor,
      });
    },
    [check, sgwtWebAnalytics],
  );

  return (
    <FormField formattedMessageId="targetAccumulator.form.firstFixingDate">
      <TradeCaptureValidationWrapper validation={validation?.firstFixingDate}>
        <DatePickerWithTenorNext
          date={firstFixingDate}
          tenor={firstFixingTenor}
          data-e2e="first-fixing-date-input"
          onChange={handleDateChange}
          disablePresets={disabledDatePresets}
        />
      </TradeCaptureValidationWrapper>
    </FormField>
  );
};

export default FirstFixingDate;
